import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { CountryService } from '../../../../../app/shared/API-Service/services/country.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

import { Image } from '../../../../../images/images'


@Component({
  selector: 'app-view-country',
  templateUrl: './view-country.component.html',
  styleUrls: ['./view-country.component.css']
})
export class ViewCountryComponent implements OnInit {
  countries:object [] = [];

  constructor(private _CountryService:CountryService, private _Router:Router) { }

  ngOnInit(): void {
    this.getcountries();
  }

  getcountries(){
    this._CountryService.GetCountry().subscribe((res) => {
      this.countries = res.data
    console.log(this.countries);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  update(data){
    this._CountryService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertCountry']);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._CountryService.DeleteCountry(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getcountries();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }

}
